export const text = '#ffffff';
export const hover = '#E72E4B';
export const title = `"Haffer", Arial, Helvetica, freesans, sans-serif `
export const title_ms60 = title;